$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * cookie-message
    // *
    // *
    var cookieMessage = Cookies.get('cookie-message');

    $(".js-cookie-message-btn").click(function () {
        $(this).parents(".js-cookie-message").fadeOut();
        Cookies.set('cookie-message', '1', { expires: 365 });
    });

    if (!cookieMessage) {
        $(".js-cookie-message").show();
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 60; // Distance from Browserbottom where the animation should start

    function fadeInElements() {
        var viewPort = $(window).scrollTop() + $(window).height();

        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top;

            if ((elementTop + offset) <= viewPort) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
             var rel = ['onepagebooking.com', 'vbooking.de'].some(domain => this.href.includes(domain)) ? 'noopener nofollow' : 'noopener';
            $(this).attr('target', '_blank').attr('rel', rel);
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        // Scroll into view if gsap site is not present
        if (!$(".js-smooth-content").length) {
            setTimeout(() => {
                $(this)[0].scrollIntoView({ behavior: 'smooth' });
            }, 400);
        }
    });

    // Open accordion with anchor link
    let hash = window.location.hash.split('#')[1];
    if ($("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
        $("#" + hash).click();
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-heroslider");

    if ($heroSlider.length) {

        var $heroSliders = {};

        $heroSlider.each(function () {

            var id = $(this).attr('id');

            $heroSliders[id] = $(this).slick({
                infinite: true,
                fade: true,
                pauseOnFocus: true,
                pauseOnHover: true,
                dots: true,
                autoplay: $(this).data("autoplay"),
                speed: 1000,
                autoplaySpeed: 7000,
                waitForAnimate: false,
                arrows: true,
                prevArrow: $(this).parents(".js-heroslider-wrapper").find(".js-slider-prev"),
                nextArrow: $(this).parents(".js-heroslider-wrapper").find(".js-slider-next"),
                responsive: []
            });
        });

        $(".js-heroslider-image").click(function () {
            var id = $(this).parents(".js-heroslider").attr('id');
            $heroSliders[id].slick("slickNext");
        });

    }




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderTeaser
    // *
    // *
    var $sliderTeaser = $(".js-sliderteaser");

    if ($sliderTeaser.length) {

        var $sliders = {};

        $sliderTeaser.each(function () {

            var id = $(this).attr('id');

            $sliders[id] = $(this).slick({
                infinite: true,
                fade: true,
                dots: true,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoplay: true,
                speed: 1000,
                autoplaySpeed: 7000,
                waitForAnimate: false,
                arrows: true,
                prevArrow: $(this).parents(".js-sliderteaser-wrapper").find(".js-slider-prev"),
                nextArrow: $(this).parents(".js-sliderteaser-wrapper").find(".js-slider-next"),
                responsive: []
            });
        });

        $(".js-sliderteaser-image").click(function () {
            var id = $(this).parents(".js-sliderteaser").attr('id');
            $sliders[id].slick("slickNext");
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * marquee
    // *
    // *

    var $marqueeItems = $(".js-marquee-item");
    for (i = 0; i < 100; i++) {
        $marqueeItems.clone().appendTo(".js-marquee");
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navMobile
    // *
    // *
    $(".js-nav-button").click(function () {
        $(this).toggleClass("active");
        $(".js-nav-mobile").toggleClass("active");
        $(".js-header").toggleClass("mobileNavActive");
    });


    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            if ($(".js-nav-button").hasClass("active")) {
                $(".js-nav-button").removeClass("active");
                $(".js-nav-mobile").removeClass("active");
                $(".js-header").removeClass("mobileNavActive");
            };
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * descSlider
    // *
    // *
    var $descSlider = $(".js-descslider");

    if ($descSlider.length) {
        $descSlider.each(function () {
            var $descSliderImages = $(this).find(".js-descslider-images"),
                $descSliderContent = $(this).find(".js-descslider-content");

            $descSliderImages.slick({
                infinite: true,
                fade: false,
                dots: false,
                arrows: true,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoplay: false,
                speed: 1000,
                prevArrow: $(this).find(".js-descslider-nav-prev"),
                nextArrow: $(this).find(".js-descslider-nav-next"),
                asNavFor: $descSliderContent,
                autoplaySpeed: 7000,
                waitForAnimate: false,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            infinite: true,
                            dots: false,
                            arrows: false,
                            variableWidth: true
                        }
                    }
                ]
            });

            $descSliderContent.slick({
                infinite: true,
                fade: false,
                dots: false,
                arrows: false,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoplay: false,
                speed: 1000,
                autoplaySpeed: 7000,
                waitForAnimate: false,
                asNavFor: $descSliderImages,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            variableWidth: true
                        }
                    }
                ]
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * slider
    // *
    // *
    var $slider = $(".js-slider");

    if ($slider.length) {
        $slider.each(function () {
            var $sliderImages = $(this).find(".js-slider-images"),
                $sliderHeader = $(this).find(".js-slider-header"),
                $sliderContent = $(this).find(".js-slider-content"),
                $asNavFor = $(this).find(".js-slider-content, .js-slider-header");

            $sliderImages.slick({
                infinite: true,
                fade: false,
                dots: false,
                pauseOnFocus: true,
                pauseOnHover: true,
                arrows: true,
                autoplay: false,
                speed: 1000,
                prevArrow: $(this).find(".js-slider-nav-prev"),
                nextArrow: $(this).find(".js-slider-nav-next"),
                autoplaySpeed: 7000,
                waitForAnimate: true,
                asNavFor: $asNavFor,
                responsive: []
            });

            $sliderHeader.slick({
                infinite: true,
                fade: true,
                dots: false,
                pauseOnFocus: true,
                pauseOnHover: true,
                arrows: false,
                autoplay: false,
                speed: 1000,
                autoplaySpeed: 7000,
                waitForAnimate: false,
                responsive: []
            });

            $sliderContent.slick({
                infinite: true,
                fade: true,
                dots: false,
                arrows: false,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoplay: false,
                speed: 1000,
                autoplaySpeed: 7000,
                waitForAnimate: false,
                responsive: []
            });

        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * bookingButton: add Class to header if window scrolls up or down
    // *
    // *
    var position = $(window).scrollTop(),
        $bookingButton = $(".js-bookingbutton");

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll > position) {
            //scroll down
            $bookingButton.addClass("scroll-down").removeClass("scroll-up");
            setTimeout(function () {
                $bookingButton.addClass("scroll-up").removeClass("scroll-down");
            }, 2000);
        } else {
            // scroll up
            $bookingButton.addClass("scroll-up").removeClass("scroll-down");
        }

        position = scroll;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * event form
    // *
    // *
    $(".js-eventform-select").change(function () {
        var selectedOption = $(".js-eventform-select option:selected").val();
        $(".js-eventform-size").addClass("active");
        $(".js-eventform-size option:eq(0)").prop("selected", true);
        $(".js-eventform-size option").hide();
        $('.js-eventform-size option[data-option="' + selectedOption + '"]').show();
    })

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * apply form: show free text field if "Sonstiges" is selected
    // *
    // *
    var $applySource = $(".js-applyform-source");

    if ($applySource.length) {
        var $applySourceOther = $(".js-applyform-source-other"),
            $applySourceOtherInput = $(".js-applyform-source-other-input");

        function toggleApplySourceOther() {
            var isOther = $applySource.val() === "Sonstiges";

            $applySourceOther.prop("hidden", !isOther);
            $applySourceOtherInput.prop("required", isOther);

            if (!isOther) {
                $applySourceOtherInput.val("");
            }
        }

        $applySource.change(toggleApplySourceOther);
        toggleApplySourceOther();
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * mobile video
    // *
    // *
    $(window).on('load resize', function () {
        if (window.innerWidth < 1080) {
            var video = $(".js-video-switcher");
            var mobileSrc = $(".js-video-switcher").data("mobile");
            if (video.length > 0) {
                video.attr('src', mobileSrc);
                video[0].load();
            }
        }
    });

    $(".js-video-volume-controls").click(function () {
        $(this).toggleClass("active");
        var video = $(this).parents(".js-video-wrapper").find("video");
        var muted = video.prop("muted");
        video.prop("muted", !muted);
    })

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState');

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        setTimeout(() => {
            sessionStorage.setItem('dialogState', true);
            $(this).parents(".js-dialog").get(0).close();
            $("body").removeClass("freeze");
        }, 400);

    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            setTimeout(() => {
                sessionStorage.setItem('dialogState', true);
                $(this).get(0).close();
                $("body").removeClass("freeze");
            }, 400);

        }
    });

    function showDialog(delay) {
        setTimeout(() => {
            if (!$dialog.get(0).open && !sessionStorage.getItem('dialogState')) {
                $dialog.get(0).showModal();
            }
        }, delay);
    }

    if (!dialogState && $dialog.length > 0) {
        var cookiebotDisplayed = false;

        // cookiebot banner is shown
        window.addEventListener("CookiebotOnDialogDisplay", function () {
            cookiebotDisplayed = true;
        });

        // show dialog directly after cookiebot banner was closed
        // (accept/decline are also fired on load if consent was given before)
        ["CookiebotOnAccept", "CookiebotOnDecline"].forEach(function (eventName) {
            window.addEventListener(eventName, function () {
                if (cookiebotDisplayed) {
                    showDialog(500);
                }
            });
        });

        // show dialog after 5 seconds if cookiebot banner is not waiting for a response
        setTimeout(() => {
            var cookiebotPending = cookiebotDisplayed && !(window.Cookiebot && Cookiebot.hasResponse);

            if (!cookiebotPending && $("body #CybotCookiebotDialog.CybotCookiebotDialogActive").length === 0) {
                showDialog(0);
            }
        }, 5000);
    }

});
